import AdminTestItemState from './state';
import { AdminTestItemTypes } from './types';

const INITIAL_STATE = new AdminTestItemState();

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //-------------------------------------------------
    // GET_TEST_LINE_LAB_OPTIONAL_LIST
    case AdminTestItemTypes.GET_TEST_LINE_LAB_OPTIONAL_LIST.LOADING:
      return {
        ...state,
        testLabList: {
          ...state.testLabList,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_LINE_LAB_OPTIONAL_LIST.SUCCESS:
      return {
        ...state,
        testLabList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_LINE_LAB_OPTIONAL_LIST.ERROR:
      return {
        ...state,
        testLabList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ADMIN_TEST_ITEM_LIST
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_LIST.LOADING:
      return {
        ...state,
        adminTestItemList: {
          ...state.adminTestItemList,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_LIST.SUCCESS:
      return {
        ...state,
        adminTestItemList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_LIST.ERROR:
      return {
        ...state,
        adminTestItemList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ADMIN_TEST_ITEM_DETAIL
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        adminTestItem: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestItem: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ADMIN_TEST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        adminTestItem: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_ADMIN_TEST_ITEM_DETAIL
    case AdminTestItemTypes.CREATE_ADMIN_TEST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        adminTestItem: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case AdminTestItemTypes.CREATE_ADMIN_TEST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestItem: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.CREATE_ADMIN_TEST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        adminTestItem: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_ADMIN_TEST_ITEM_DETAIL
    case AdminTestItemTypes.UPDATE_ADMIN_TEST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        adminTestItem: {
          ...state.adminTestItem,
          loading: true,
          error: null,
        },
      };
    // case AdminTestItemTypes.UPDATE_ADMIN_TEST_ITEM_DETAIL.SUCCESS:
    //   return {
    //     ...state,
    //     adminTestItem: {
    //       loading: false,
    //       data: action.payload,
    //       error: null,
    //     },
    //   };
    case AdminTestItemTypes.UPDATE_ADMIN_TEST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        adminTestItem: {
          ...state.adminTestItem,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_ADMIN_TEST_ITEM_DETAIL
    case AdminTestItemTypes.DELETE_ADMIN_TEST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        adminTestItem: {
          ...state.adminTestItem,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.DELETE_ADMIN_TEST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestItem: {
          loading: false,
          data: {},
          error: null,
        },
      };

    case AdminTestItemTypes.DELETE_ADMIN_TEST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        adminTestItem: {
          ...state.adminTestItem,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_CITATION_LIST
    case AdminTestItemTypes.GET_CITATION_LIST.LOADING:
      return {
        ...state,
        citationList: {
          loading: true,
          data: [],
          error: null,
        },
      };
    case AdminTestItemTypes.GET_CITATION_LIST.SUCCESS:
      return {
        ...state,
        citationList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case AdminTestItemTypes.GET_CITATION_LIST.ERROR:
      return {
        ...state,
        citationList: {
          ...state.citationList,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ARCHIVE_LIST
    case AdminTestItemTypes.GET_ARCHIVE_LIST.LOADING:
      return {
        ...state,
        archiveList: {
          ...state.archiveList,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ARCHIVE_LIST.SUCCESS:
      return {
        ...state,
        archiveList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_ARCHIVE_LIST.ERROR:
      return {
        ...state,
        archiveList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_TEST_ITEM_TYPE
    case AdminTestItemTypes.GET_TEST_ITEM_TYPE.LOADING:
      return {
        ...state,
        testItemType: {
          ...state.testItemType,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_ITEM_TYPE.SUCCESS:
      return {
        ...state,
        testItemType: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_ITEM_TYPE.ERROR:
      return {
        ...state,
        testItemType: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    // GET_TEST_ITEM_TYPE
    case AdminTestItemTypes.GET_TEST_ITEM_PRODUCTS.LOADING:
      return {
        ...state,
        testItemProducts: {
          ...state.testItemProducts,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_ITEM_PRODUCTS.SUCCESS:
      return {
        ...state,
        testItemProducts: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.GET_TEST_ITEM_PRODUCTS.ERROR:
      return {
        ...state,
        testItemProducts: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    // ARCHIVE_ADMIN_TEST_ITEM
    case AdminTestItemTypes.ARCHIVE_ADMIN_TEST_ITEM.LOADING:
      return {
        ...state,
        archiveAdminTestItem: {
          ...state.archiveAdminTestItem,
          loading: true,
          error: null,
        },
      };
    case AdminTestItemTypes.ARCHIVE_ADMIN_TEST_ITEM.SUCCESS:
      return {
        ...state,
        archiveAdminTestItem: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestItemTypes.ARCHIVE_ADMIN_TEST_ITEM.ERROR:
      return {
        ...state,
        archiveAdminTestItem: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
